import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { isStudyEnrolled, mapStateToPropsLogin } from "../../modules/login";

export class ProtectedRouteBase extends React.Component {
  static propTypes = {
    authorize: PropTypes.array.isRequired,
    study: PropTypes.string,
    studies: PropTypes.array,
    unauthorizedStudyStatus: PropTypes.array,
    genericRoute: PropTypes.bool,
    redirectNonAuthorized: PropTypes.string,
    computedMatch: PropTypes.object, // private, from <Switch>
    path: PropTypes.string,
    exact: PropTypes.bool,
    strict: PropTypes.bool,
    sensitive: PropTypes.bool,
    component: PropTypes.func,
    render: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    location: PropTypes.object,
  };

  static defaultProps = {
    authorize: [],
  };

  componentDidMount = () => {
    const { onProtectedRouteChange, userProfile } = this.props;
    if (onProtectedRouteChange) {
      onProtectedRouteChange(userProfile);
    }
  };

  isAuthorized() {
    const { authorize, userProfile } = this.props;
    const roleIntersection = [...authorize].filter(
      (role) => role === userProfile
    );

    // Check if our user's role is present in the possible roles
    if (authorize.length > 0 && roleIntersection.length === 0) {
      return false;
    }

    return true;
  }

  render() {
    const {
      redirectNonAuthorized,
      redirectNonStudyEnrolled,
      genericRoute,
      userProfile,
      study,
      studies,
      unauthorizedStudyStatus,
    } = this.props;
    if (!this.isAuthorized()) {
      if (redirectNonAuthorized) {
        return <Redirect to={redirectNonAuthorized} />;
      }
      return null;
    } else if (!isStudyEnrolled(study, studies, unauthorizedStudyStatus)) {
      if (redirectNonStudyEnrolled) {
        return <Redirect to={redirectNonStudyEnrolled} />;
      }
      return null;
    } else if (genericRoute) {
      return <Redirect to="/home" />;
    } else return <Route {...this.props} />;
  }
}

export default connect(mapStateToPropsLogin, {})(ProtectedRouteBase);
